<div fxFlex fxLayout="column">
  <div class="sticky" fxFlex>
    <iot-platform-ui-toolbar-v2
      (dispatchToolbarEvent)="onToolbarEvent($event)"
      [buttonList]="adminUsersButtonList"
      [isDataLoaded]="!(usersPending$ | async)"
      [name]="'I18N_ADMIN.USERS.TOOLBAR_TITLE' | translate"
      [total]="totalUsers$ | async"
      [size]="ToolbarSize.SMALL"
    >
    </iot-platform-ui-toolbar-v2>

    <iot-platform-ui-filter-engine-v2
      (applyFilters)="onApplyFilters($event)"
      [currentFavoriteView]="currentFavoriteView$ | async"
      [currentFilters]="currentFilters$ | async"
      [expanded]="filterEngineOpened"
      [masterView]="'admin-users'"
    />
  </div>
  <div class="p-4" fxFlex fxLayout="row">
    <i4b-table-engine-master-view-engine
      (dispatchMasterViewEngineEvent)="onDispatchMasterViewEngineEvent($event)"
      (pageChange)="loadMoreUsers($event)"
      [data]="users$ | async"
      [masterViewType]="{ name: 'admin-users', isPath: false }"
      [sticky]="true"
      [useExternalData]="true"
      [userPermissions]="userPermissions$ | async"
    />
  </div>
</div>
